import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import Tile from '../layout/Tile'
import TimeHelper from '../../helpers/TimeHelper'
import _ from 'lodash'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined'
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined'

interface P {
    tableId: string
}

function ActivityModal({ tableId }: P) {
    const activities: { tableId: string, date: string, type: 'update' | 'remove' | 'insert' }[] = [
        { date: TimeHelper.now().day(-180).format('MM-DD-YYYY'), tableId: tableId, type: 'insert' },
        { date: TimeHelper.now().day(-100).format('MM-DD-YYYY'), tableId: tableId, type: 'insert' },
        { date: TimeHelper.now().day(-90).format('MM-DD-YYYY'), tableId: tableId, type: 'insert' },
        { date: TimeHelper.now().day(-85).format('MM-DD-YYYY'), tableId: tableId, type: 'update' },
        { date: TimeHelper.now().day(-62).format('MM-DD-YYYY'), tableId: tableId, type: 'insert' },
        { date: TimeHelper.now().day(-30).format('MM-DD-YYYY'), tableId: tableId, type: 'update' },
        { date: TimeHelper.now().day(-22).format('MM-DD-YYYY'), tableId: tableId, type: 'remove' },
        { date: TimeHelper.now().day(-7).format('MM-DD-YYYY'), tableId: tableId, type: 'update' },
        { date: TimeHelper.now().day(-1).format('MM-DD-YYYY'), tableId: tableId, type: 'update' }
    ]
    const groupedActivities = _.groupBy(_.orderBy(activities, x => x.date, 'desc'), x => TimeHelper.formatDateDifference(x.date))

    return (
        <Tile.Tile style={{ minWidth: 500, maxHeight: '80vh', overflowY: 'auto' }}>
            {TimeHelper.timeOrderedGroups.map(key => {
                const groupActivities = groupedActivities[key]
                if (!groupActivities || groupActivities.length === 0) return

                return (
                    <Accordion variant='elevation' key={key}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            {key}
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                {groupActivities.map((activity, i) => {
                                    return (
                                        <Box key={i} display='flex' flexDirection='row' alignItems='center' marginBottom={2}>
                                            {activity.type === 'remove'
                                                ? <DeleteForeverOutlinedIcon />
                                                : activity.type === 'insert'
                                                    ? <BackupOutlinedIcon />
                                                    : <UpdateOutlinedIcon />}
                                            <Box flexDirection='column' marginLeft={2} justifyContent='flex-start'>
                                                <Typography variant='body1'>{_.capitalize(activity.type)}: {_.capitalize(activity.tableId)} table</Typography>
                                                <Typography fontSize={14} lineHeight={1} color='GrayText'>{activity.date}</Typography>
                                            </Box>
                                        </Box>
                                    )
                                })}
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </Tile.Tile>
    )
}

export default ActivityModal
